import { useEffect, useState, createContext } from "react";
import { Routes, Route } from "react-router-dom";
import InicioSesion from "@InicioSesion/InicioSesion";
import Principal from "@Principal/Principal";
import Error from "@Error/Error";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _f_ from "@Funciones/funciones";
import "./App.css";
export const Contexto = createContext();

function App() {
  const [cv_u, ecv_u] = useState(null);
  const [navegacion, enavegacion] = useState([]);
  const [opcionMenu, eopcionMenu] = useState(null);
  const [usuarioSesion, eusuarioSesion] = useState(
    _f_.obtenerCookie("usuario") !== null
      ? _f_.obtenerCookie("usuario").toUpperCase().trim()
      : "",
  );
  const [rolUsuarioSesion,erolUsuarioSesion] = useState(
     _f_.obtenerCookie("codRol") !== null
      ? _f_.obtenerCookie("codRol").toUpperCase().trim()
      : "",
  )
  const [v_u, ev_u] = useState(null);

  const [esComputadora, setesComputadora] = useState(
    window.innerWidth > window.innerHeight,
  );
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setesComputadora(window.innerWidth > window.innerHeight);
      setScreenWidth(window.screen.width);
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const screenHeight = window.screen.height;
    const esDimComputadora = screenWidth > screenHeight;
    const fontSize = esComputadora
      ? screenWidth * 0.008
      : esDimComputadora
        ? screenWidth * 0.008
        : screenWidth * 0.023;
    document.documentElement.style.setProperty(
      "--font-size-javascript",
      `${fontSize}px`,
    );
  }, [screenWidth]);

  useEffect(() => {
    cv_u &&
      ev_u({
        error: cv_u.error,
        errorCod: cv_u.errorCod,
        errorDsc: cv_u.errorDsc,
        visible: cv_u.visible,
        contenido: cv_u.contenido,
        origen: cv_u.origen,
      });
  }, [cv_u]);

  return (
    <Contexto.Provider
      value={{
        cv_u,
        ecv_u,
        navegacion,
        enavegacion,
        opcionMenu,
        eopcionMenu,
        esComputadora,
        screenWidth,
        innerWidth,
        usuarioSesion,
        eusuarioSesion,
        rolUsuarioSesion,
        erolUsuarioSesion
      }}
    >
      {v_u?.visible && (
        <ModalInformacion
          titulo={`🚨 Advertencia ${v_u.errorCod == 3 ? "[" + v_u.errorDsc + "]" : ""}`}
          respuesta={v_u}
        >
          <Error error={v_u} />
        </ModalInformacion>
      )}
      <Routes>
        <Route path="/" element={<InicioSesion />} />
        <Route path="/principal" element={<Principal />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Contexto.Provider>
  );
}

export default App;
